import { useEffect, useState } from 'react';
import { prefetchRulesReferenceData } from '../services/prefetchRulesReferenceData';

/**
 * Incrementa cuando termina la precarga de integraciones, productos y valores de condiciones.
 * Usar en vistas que muestran resúmenes legibles antes de abrir el formulario (cards de reglas).
 */
export function useRulesReferenceDataEpoch(): number {
  const [epoch, setEpoch] = useState(0);

  useEffect(() => {
    void prefetchRulesReferenceData().finally(() => {
      setEpoch((e) => e + 1);
    });
  }, []);

  return epoch;
}
